import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(() => ({
  tabLabel: {
    textTransform: 'none',
  },
}));
